import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./LikeablePosts.scoped.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faN } from "@fortawesome/free-solid-svg-icons";
import { useQuery } from "react-query";
import { ILikelounge, getLikeList } from "api/postListApi";
import { useRecoilValue } from "recoil";
import { langCodeState } from "recoil/commonUiAtom";
import { dateFormType1, redirectURL } from "utils/CommonFunc";
import FourListLoading from "components/common/loading/FourListLoading";
import { deletetag } from "utils/DeleteTag";
import { useInView } from "react-intersection-observer";
import NotContent from "components/community/pageRight/PostContent/NotContent";
import ScrollLoading from "components/community/pageRight/PostContent/ScrollLoading";
import { useInfiniteScrollQuery } from "api/profileLikePostApi";
import { isLauncherState } from "recoil/userInfoAtom";

const tabList = [
  { name: "라운지", class: "lounge-tab" },
  { name: "게시글", class: "post-tab" }
];

interface IPosts {
  content: string;
  created_at: string;
  image: string[] | null;
  title: string;
  writer: string;
  writer_thumbnail: string | null;
  url: string;
}

function LikeablePosts() {
  const { profilekey } = useParams();
  const langCode = useRecoilValue(langCodeState);
  const [selecMenu, setSelectMenu] = useState("lounge-tab");
  const isLauncher = useRecoilValue(isLauncherState);

  const { isLoading, data } = useQuery<ILikelounge>(
    ["like-lounge"],
    () => getLikeList(profilekey || "", langCode, "lounge"),
    {
      refetchOnWindowFocus: false,
      notifyOnChangeProps: "tracked",
      enabled: selecMenu === "lounge-tab"
    }
  );

  const { getBoard, getNextPage, getBoardIsSuccess, getNextPageIsPossible } =
    useInfiniteScrollQuery();

  const [ref, isView] = useInView();

  useEffect(() => {
    if (isView && getNextPageIsPossible) {
      getNextPage();
    }
  }, [isView, getBoard]);

  const clickSection = (selecMenu: string) => {
    setSelectMenu(selecMenu);
  };

  return (
    <div className="page-right" id="LikeablePosts">
      <ul className="tab">
        {tabList.map((i, idx) => (
          <li onClick={() => clickSection(i.class)} key={idx}>
            <Link to="#" className={i.class === selecMenu ? "on" : ""}>
              {i.name}
            </Link>
          </li>
        ))}
      </ul>

      <div className="cont">
        {selecMenu === "lounge-tab" ? (
          !isLoading ? (
            <ul>
              {data?.result === 1
                ? data.data.map((i, idx: number) => (
                    <li key={idx}>
                      <img src={i.thumbnail} />
                      <div>
                        <div>
                          <p>{i.title}</p>
                          {i.is_new && (
                            <span>
                              <FontAwesomeIcon icon={faN} />
                            </span>
                          )}
                        </div>
                        <div className="btns">
                          <button
                            onClick={() =>
                              redirectURL(i.lounge_url, "_self", isLauncher)
                            }
                          >
                            Lounge
                            <FontAwesomeIcon icon={faAngleRight} />
                          </button>
                          <button
                            onClick={() =>
                              redirectURL(i.library_url, "_self", isLauncher)
                            }
                          >
                            Library
                            <FontAwesomeIcon icon={faAngleRight} />
                          </button>
                        </div>
                      </div>
                    </li>
                  ))
                : null}
            </ul>
          ) : (
            <FourListLoading />
          )
        ) : selecMenu === "post-tab" ? (
          <div>
            {getBoardIsSuccess ? (
              getBoard?.pages[0].result === 1 ? (
                getBoard?.pages.map((pageData) =>
                  pageData.boardpage.map((i: IPosts, idx: number) => (
                    <div
                      className="box"
                      key={idx}
                      onClick={() => redirectURL(i.url, "_self", isLauncher)}
                    >
                      <div>
                        <div className="title">{deletetag(i.title, [])}</div>
                        <p className="ellipsis-multi">
                          {deletetag(i.content, [])}
                        </p>
                        <div className="info">
                          <span>
                            <img
                              className="user-pic"
                              src={
                                i.writer_thumbnail !== null
                                  ? i.writer_thumbnail
                                  : "https://file.valofe.com/Valofe_file/web/vfun-ko/images/common/img-user-default-min.png"
                              }
                              alt="user icon"
                            />
                          </span>
                          <span className="nickname">{i.writer}</span>
                          <span className="time">
                            {dateFormType1(i.created_at)}
                          </span>
                        </div>
                      </div>
                      <div className="img">
                        {i.image !== null && <img src={i.image[0]} />}
                      </div>
                    </div>
                  ))
                )
              ) : (
                <NotContent />
              )
            ) : null}

            <ScrollLoading
              loadingConditions={
                getNextPageIsPossible === true &&
                getBoard?.pages[0].result === 1
              }
              viewRef={ref}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default LikeablePosts;
